import { Dispatch, FC, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { Email } from '@mui/icons-material'
import { Box, Paper, Typography } from '@mui/material'

import { usePOST_requestResetPasswordMutation } from 'redux/api/authApi'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'

import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useMedia } from 'utils/customHooks/useMedia'
import { ELEMENT_RADIUS } from 'utils/customizedTheme'
import formModel, { initialValues, validationSchema } from 'utils/formModels/requestPasswordResetModel'

import logo from 'assets/svg/logo.svg'

import { AuthType } from 'types'

interface IProps {
  setAuthState: Dispatch<SetStateAction<AuthType>>
}

const RequestNewPasswordForm: FC<IProps> = ({ setAuthState }) => {
  const { t } = useTranslation()
  const { isUnder1200px } = useMedia()

  const { email } = formModel()

  // Get reset password link on email
  const [POST_requestResetPassword, { isLoading, isSuccess, error }] = usePOST_requestResetPasswordMutation()
  useErrorAlert(error)

  return (
    <Paper
    className="transparent-background"
      elevation={0}
      sx={{
        borderRadius: ELEMENT_RADIUS,
        overflow: 'hidden',
        marginTop: '-3rem',
        width: isUnder1200px ? '90%' : '30rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        component='img'
        sx={{
          height: 'auto',
          width: '10rem',
          margin: '0 auto'
        }}
        alt='EsyBee'
        src={logo}
      />
      <Typography
        variant='h2'
        sx={{ textAlign: 'center', fontSize: '3rem', fontWeight: '200', marginTop: '3rem'}}
      >
        {t('reset.header')}
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => POST_requestResetPassword(values)}
      >
        <Form>
          <Box sx={{ padding: '1.5rem', minHeight: '10rem' }}>
            {isSuccess ? (
              <>
                <Typography sx={{ fontWeight: '300', margin: '1rem auto', padding: '1.5rem' }}>
                  {t('reset.link-send')}
                </Typography>
              </>
            ) : (
              <>
                <Typography sx={{ fontWeight: '300', margin: '1rem auto' }}>{t('reset.info')}</Typography>
                <InputField
                  fieldProps={{ ...email }}
                  icon={<Email color='primary' sx={{ mr: 1, my: 0.5 }} />}
                />
                <SubmitButton
                  text={t('reset.button-text')}
                  sx={{ marginTop: '2rem' }}
                  isLoading={isLoading}
                />
              </>
            )}
          </Box>
        </Form>
      </Formik>
      <Typography
        onClick={() => setAuthState('login')}
        sx={{
          fontSize: '0.8rem',
          color: '#9fa0a4',
          textAlign: 'center',
          margin: '-0.5rem 0 0.7rem',
          cursor: 'pointer',
          '&:hover': { textDecoration: 'underline', color: 'inherit' },
        }}
      >
        {!isSuccess && t('reset.back-to-login')}
      </Typography>
    </Paper>
  )
}
export default RequestNewPasswordForm
